// extracted by mini-css-extract-plugin
export var cardIcon = "_4l-4";
export var checkboxCard = "_4l-0";
export var checkboxCardSelected = "_4l-3";
export var disabled = "_4l-1";
export var outerBorder = "_4l-2";
export var spacerMedium = "_4l-7";
export var spacerSmall = "_4l-6";
export var spacerXsmall = "_4l-5";